// @ts-nocheck
import React, { useCallback, useEffect, useRef, useState } from "react";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import {
  SearchProvider,
  ErrorBoundary,
  SearchBox,
} from "@elastic/react-search-ui";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import ErrorBoundaryView from "./ErrorBoundaryView";
import { Trans, useTranslation } from "react-i18next";
import i18n from "../i18n";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import axios from "axios";
import configData from "../../../config.json";
import { Chip, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchResult from "./partials/SearchResult";
import AutoSuggest from "./partials/AutoSuggest";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
// import "../css/style.css";
import "../css/app-searchbar-style.css";
import SuggestionsFields from "./partials/SuggestionsFields";
import "../css/app-search-style.css";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";

import { createContext } from "react";

import {
  DEFAULT_FACETS,
  DEFAULT_FIELDS,
  PRODUCTS_NOT_FOUND,
  SHOW_MORE_RESULTS,
  SUGGESTIONS_NOT_FOUND,
  NUMBER_OF_SUGGESTIONS,
  autocompleteMinimumCharacters,
  engineCodeName,
  engineFamilyName,
  exactSearch,
  filterCharacters,
  filters,
  height,
  languageId,
  numResults,
  onDeleteProductCode,
  onProductAddedToCart,
  onProductAddedToList,
  onProductDeletedFromCart,
  onProductQtyModifiedOnCart,
  onProductSelected,
  openOn,
  openProduct,
  productSelectedField,
  resultsFields,
  searchAsYouType,
  searchFields,
  searchTerm,
  selectorOnly,
  shouldClearFilters,
  showAddToCart,
  showAddToList,
  showLensIcon,
  showMoreResults,
  showSearchButton,
  showSelectButton,
  showPlusQtyButton,
  showPlusButton,
  showSuggestionCombo,
  showWebCodeTab,
  suggestionCodeFields,
  suggestionEnabled,
  suggestionFamilyFields,
  width,
  elementId,
  customFilterManufacturer,
  customFilterManufacturerIds  
} from "./partials/constants";
const useStyles = makeStyles({
  paper: {
    padding: "50px",
    height: "335px",
  },
});
const defaultConfig = {
  alwaysSearchOnInitialLoad: true,
  trackUrlState: false,
  initialState: { searchTerm: "" },
  searchQuery: {
    /*search_fields: { id: {} },*/
    facets: DEFAULT_FACETS,
    precision: 5,
  },
  autocompleteQuery: {
    suggestions: {
      types: {
        documents: {
          fields: DEFAULT_FIELDS,
        },
      },
      size: NUMBER_OF_SUGGESTIONS,
    },
  },
  hasA11yNotifications: true,
};

const AppSearchBar = (props) => {
  const {
    width,
    height,
    family,
    family_list,
    express,
    logged,
    tariffMap,
    sortDirection,
    sortField,
    price_sort,
    client_country_id,
    jwt,
    api_url,
    api_origin,
    customFilterManufacturer,
    customFilterManufacturerIds,
    fav_products,
    cartList,
    languageId,
    engineCodeName,
    engineFamilyName,
    searchFields,
    exactSearch,
    suggestionCodeFields,
    suggestionFamilyFields,
    suggestionEnabled,
    showAddToCart,
    showAddToList,
    showSearchButton,
    showPlusQtyButton,
    showPlusButton,
    showSelectButton,
    showWebCodeTab,
    showLensIcon,
    openProduct,
    openOn,
    searchTerm,
    autocompleteMinimumCharacters,
    searchAsYouType,
    onDeleteProductCode,
    onProductSelected,
    // selectedProduct,
    // selectedProductId,
    shouldClearFilters,
    filterCharacters,
    filters,
    numResults,
    resultsFields,
    showMoreResults,
    showSuggestionCombo,
    selectorOnly,
    productSelectedField,
    onProductAddedToCart,
    onProductQtyModifiedOnCart,
    onProductDeletedFromCart,
    onProductAddedToList,
    elementId,
    shop_id
  } = props;

  const classes = useStyles();

  const TabPanel = (props) => {
    return <div>{props.children}</div>;
  };
  // state parameters
  const [familyParam, setFamilyParam] = useState(family);
  const [elementIdParam, setElementIdParam] = useState(elementId);
  const [isFamilyFlag, setIsFamilyFlag] = useState(false);
  const [tabValue, setTabValue] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(searchTerm);
  const [suggestionResults, setSuggestionResults] = useState();
  const [productResults, setProductResults] = useState();
  const [selectedProductsCode, setSelectedProductsCode] = useState([]);
  const [selectedProductField, setSelectedProductField] = useState();
  const [codeFields, setCodeFields] = useState(suggestionCodeFields);
  const [familyFields, setFamilyFields] = useState(suggestionFamilyFields);
  const [selected, setSelected] = useState();
  const [visible, setVisible] = useState(false);
  
  function handleReset() {
    onDeleteSelectedChip(selectedProductsCode[0]);
    setSelectedProductsCode([]);
    setSearchQuery("");
    setSelectedProductField("");
  }
  if (typeof window !== "undefined") {
    window.addEventListener("resetAppSearchBar", handleReset.bind(this));
  }

  
  // setVisible((productResults || suggestionResults) && searchQuery.length > 0 && selectedProductsCode.length === 0);

  // Elastic search api connector
  const connector = new AppSearchAPIConnector({
    searchKey: configData.searchKey,
    engineName:
      family == "" || family == null
        ? configData.engineName + "-" + shop_id
        : configData.engineName + "-" + shop_id + "-" + family,
    endpointBase: configData.endpointBase,
  });

  // Default elastic-search configuration
  const [config, setConfig] = useState({
    ...defaultConfig,
    apiConnector: connector,
    initialState: { searchTerm: searchTerm },
    a11yNotificationMessages: {
      searchResults: ({ start, end, totalResults, searchTerm }) => {
        const sanitizeSearch = (searchTerm) => {
          let sanitizeSearchTerm = "";
          for (var i = 0; i < searchTerm.length; i++) {
            const add = filterCharacters.includes(searchTerm.at(i))
              ? " "
              : searchTerm.at(i);
            sanitizeSearchTerm = sanitizeSearchTerm + add;
          }
          return sanitizeSearchTerm;
        };
        const searchText = sanitizeSearch(searchTerm);
        setSearchQuery(searchText);
        // return `Searching for "${searchTerm}". Showing ${start} to ${end} results out of ${totalResults}.`;
      },
    },
  });

  /**
   * This function use for get auto suggestions based on query value
   * @param {*} query => query value
   */
  const fetchSuggestions = useCallback(
    (query) => {
      const resSuggestion = async () => {
        //setProductResults();
        const reqBody = {
          query,
          ...config.autocompleteQuery.suggestions,
        };
        const header = {
          headers: { Authorization: `Bearer ${configData.searchKey}` },
        };
        const URL =
          configData.endpointBase +
          "/api/as/v1/engines/" +
          configData.engineName +
          "-" +
          shop_id;
        try {
          const { data } = await axios.post(
            `${URL}/query_suggestion`,
            reqBody,
            header
          );
          setSuggestionResults(data);
          setVisible(true);
        } catch (error) {
          console.log(error);
        }
      };
      resSuggestion();
    },
    [config]
  );

  /**
   * This function use for get products based on query value
   * @param {*} query => query value
   */
  const fetchProducts = async (query) => {
    try {
      const reqBody = {
        page: { size: numResults, current: 1 },
        query: query,
        facets: config.searchQuery.facets,
        filters: {},
        precision: config.searchQuery.precision,
      };
      const header = {
        headers: { Authorization: `Bearer ${configData.searchKey}` },
      };

      if (tabValue === 0) {
        reqBody.search_fields = { ...config.searchQuery.search_fields, id: {} };
      } else {
        delete reqBody.search_fields;
      }
      if (shouldClearFilters) {
        delete reqBody.filters;
      } else {
        reqBody.filters = filters;
      }

      const URL =
        configData.endpointBase +
        "/api/as/v1/engines/" +
        configData.engineName +
        "-" +
        shop_id;

      const { data } = await axios.post(`${URL}/search.json`, reqBody, header);
      setProductResults(data.results);
      setVisible(true);

    } catch (error) {
      console.log(error);
    }
  };

  

  const f_name = Object.entries(family_list).map(([key, value]) => ({
    key,
    value,
  }));

  let familyName;
  if (familyParam) {
    f_name?.length > 0 &&
      f_name.map((f) => {
        if (f.key == familyParam) {
          familyName = f.value.toLowerCase();
        }
      });
  }

  const wrapperRef = useRef(null);

  useEffect(() => {
    if (localStorage.getItem("search_mode") === "id") {
      setTabValue(0);
    }
    document.addEventListener("click", clickedOutside, true);
    return () => {
      document.removeEventListener("click", clickedOutside, true);
    };
  }, []);

  const clickedOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setVisible(false);
    }
  };

  const closePopup = (event) => {
    setVisible(false);
  };

  useEffect(() => {
    if (searchQuery.length > 0) {
      setVisible(true);
      setSelectedProductsCode((prevState) => {
        return prevState.filter(
          (productcode) => productcode !== selectedProductsCode[0]
        );
      });
    }
    setSelected();
    if (searchQuery.length === 0) {
      setVisible(false);
      setSuggestionResults();
      setProductResults();
    }
    if (
      searchAsYouType &&
      searchQuery?.length >= autocompleteMinimumCharacters
    ) {
      if (suggestionEnabled && tabValue === 1) {
        fetchSuggestions(searchQuery);
        fetchProducts(searchQuery);
      } else {
        fetchProducts(searchQuery);
      }
    }
  }, [searchQuery]);

  // useEffect((prevProps)=> {
  //   if (from === CUSTOM_SEARCH_BAR) {
  //     const { resultSearchTerm } = props;
  //     parseTariffs(props.data, resultSearchTerm);
  //     getCartData();
  //     const queryString = window.location.search;
  //     const urlParams = new URLSearchParams(queryString);
  //     const category = urlParams.get("category");
  //     const url = new URL(window.location.href);
  //     //url.searchParams.set("view", props.typeView);
  //   } else {
  //     const { resultSearchTerm } = props;
  //     parseTariffs(props.data, resultSearchTerm);
  //     getCartData();
  //     let products = props.data.map(obj => obj.id.raw);
  //     if(products.length>0) {
  //       getStockData(products);
  //     }
  //     const queryString = window.location.search;
  //     const urlParams = new URLSearchParams(queryString);
  //     const category = urlParams.get("category");
  //     const url = new URL(window.location.href);
  //     //url.searchParams.set("view", props.typeView);
  //     const { searchMode, addFilter, clearFilter } = state;

  //     if (props.sortField !== "") {
  //       if (props.sortField == "main_family") {
  //         setState({
  //           isFamilyFlag: true,
  //         });
  //       } else {
  //         setState({
  //           isFamilyFlag: false,
  //         });
  //       }
  //     }

  //     if (props.typeView !== "") {
  //       setState({
  //         typeView: props.typeView,
  //       });
  //     }

  //     if (searchMode != "id") {
  //       if (category != "id") {
  //         // Cargar filtros por defecto
  //         addFilter("not_discontinued", "true", "any");
  //         // addFilter("main_color", "true", "any");
  //       }
  //     } else {
  //       clearFilter();
  //     }
  //   }
  // },[])

  useEffect(() => {
    if (suggestionResults || productResults) {
      if (
        suggestionResults?.results?.documents?.length > 0 ||
        productResults?.length > 0
      ) {
        setVisible(true);
      }
    }
  }, [suggestionResults, productResults]);

  useEffect(() => {
    if (tabValue === 0) {
      const autocompleteQuery = {
        suggestions: {
          types: {
            documents: {
              fields: codeFields,
            },
          },
        },
      };
      const newConfig = { ...config, autocompleteQuery };
      setConfig(newConfig);
    } else {
      localStorage.removeItem("search_mode");
      const autocompleteQuery = {
        suggestions: {
          types: {
            documents: {
              fields: familyFields,
            },
          },
        },
      };
      const newConfig = { ...config, autocompleteQuery };
      setConfig(newConfig);
    }
  }, [tabValue]);

  // console.log('config::', config)

  useEffect(() => {
    i18n.changeLanguage(languageId);
    document.body.classList.add("checkBTn2");
    return;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // console.log("queryString::",productResults)

    var url = new URL(window.location.href);
    url.searchParams.set("engine", "");
    url.searchParams.set("search_mode", "text");
    window.history.replaceState(null, null, url);

    let engine = urlParams.get("engine");
    if (family == null || family == undefined) {
      family = "";
    }
    if (engine == null || engine == undefined) {
      engine = "";
    }
    if (family != engine) {
      if (engine != family) {
        axios
          .post("/familysession.php", {
            family: engine,
          })
          .then(function (response) {
            if (trackUrlState) location.reload();
          })
          .catch(function (error) {
            //
          });
      }
    }
  }, []);

  // url parameters
  //   var url = new URL(window.location.href);
  //   url.searchParams.set("engine", "");
  //   url.searchParams.set("search_mode", "id");
  //   window.history.replaceState(null, null, url);

  /**
   * This function use for get selected suggetions value
   * @param {suggestionItem}  => suggestion value
   * @param {i}  => suggestion key index
   */
  const handleQuerySuggestions = async (suggestionItem, i) => {
    fetchProducts('"' + suggestionItem + '"');
    setSelected(i);
  };

  let count = 0;

  // On select product function
  const handleSelectedProductClick = (product) => {
    if (count === 0) {
      if (selectorOnly) {
        setVisible(false);
      }
      const selectedProductField = product[productSelectedField];
      const fieldValue = selectedProductField.raw;
      if (selectorOnly) {
        setSelectedProductField(fieldValue);
        count++;
      }
      sentEventData("onProductSelected", fieldValue);
    }

    if (selectorOnly) {
      setSelectedProductsCode((prevState) => {
        if (prevState.includes(product.webcode.raw)) {
          return prevState;
        } else {
          return [...prevState, product.webcode.raw];
        }
      });
    }
  };

  // On Delete select product chip function
  const onDeleteSelectedChip = (code) => {
    setSelectedProductsCode((prevState) => {
      setSelectedProductsCode((prevState) => {
        return prevState.filter((productcode) => productcode !== code);
      });
    });
    setVisible(true);
    onDeleteProductCode(selectedProductsCode[0]);
  };

  // On click suggestin-combo modal will open
  const handleClickSuggestions = () => {
    setIsOpen((prev) => !prev);
  };

  /**
   * Upon SuggestionFields selection changes - query suggestions changes
   * @param {*} el => UpdatedSuggestionFields
   */
  const handleSuggestionFields = (el) => {
    const autocompleteQuery = {
      suggestions: {
        types: {
          documents: {
            fields: el,
          },
        },
      },
    };
    const newConfig = { ...config, autocompleteQuery };
    setConfig((prev) => {
      return { ...prev, autocompleteQuery };
    });
    setFamilyFields(el);
  };

  // Modal close action
  const handleClose = () => {
    setIsOpen(false);
  };

  // Switching tab => Web Code
  const handleWebCodeSearch = () => {
    setTabValue(0);
    localStorage.setItem("search_mode", "id");
  };

  // On Enter stop search
  const onKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  // On Search Button Clicked
  const submitData = (searchTerm) => {
    window.location.assign(
      window.location.origin +
        "/search/" +
        (searchQuery != "" ? "?q=" + searchQuery : "")
    );
  };

  const sentEventData = (eventType, eventPayload) => {
    var event = new CustomEvent(eventType, {
      detail: {
        payload: eventPayload,
      },
    });
    document.getElementById(elementIdParam).dispatchEvent(event);
    //window.dispatchEvent(event);
  };

  const { t } = useTranslation();

  return (
    <div className="app-search-bar">
      <MyContext.Provider value={{ searchQuery }}>
        <SearchProvider config={config}>
          <div className="App" ref={wrapperRef}>
            <div className="sui-layout sui-layout-buy">
              <ErrorBoundary view={ErrorBoundaryView}>
                <div className="sui-layout-header">
                  <div className="sui-layout-header__inner">
                    <div className="sui-layout-header-row">
                      <div className="SearchBar">
                        <Grid container>
                          <Grid
                            className={`${
                              selectorOnly && selectedProductsCode.length > 0
                                ? "chip-visible"
                                : ""
                            } search-tab-wrapper`}
                          >
                            {showWebCodeTab && (
                              <div className="search-tab-header">
                                <div className="search-label">
                                  <Trans>Searching in</Trans>:
                                </div>
                                <AppBar
                                  position="static"
                                  className="tab-heading"
                                >
                                  <Tabs value={tabValue}>
                                    <Tab
                                      label={engineCodeName}
                                      onClick={handleWebCodeSearch}
                                    />
                                    <Tab
                                      label={
                                        tabValue === 0
                                          ? t("Text/Ref./Keywords")
                                          : engineFamilyName
                                          ? engineFamilyName
                                          : t("all families")
                                      }
                                      onClick={() => setTabValue(1)}
                                    />
                                  </Tabs>
                                </AppBar>
                              </div>
                            )}
                            <TabPanel>
                              {selectedProductsCode.length === 0 ? (
                                <Grid
                                  key={"searchBox"}
                                  className="searchbar-right"
                                  item
                                  sm={12}
                                  style={{ width: width }}
                                >
                                  <SearchBox
                                    inputView={({
                                      getAutocomplete,
                                      getInputProps,
                                      getButtonProps,
                                    }) => (
                                      <>
                                        {!showLensIcon ? (
                                          <div
                                            className={`${
                                              tabValue !== 1
                                                ? "no-suggestion"
                                                : ""
                                            } sui-search-box__wrapper relative`}
                                          >
                                            <div
                                              className={
                                                searchQuery.length > 0
                                                  ? "open-search"
                                                  : ""
                                              }
                                            >
                                              <input
                                                style={{ height: height }}
                                                className="sui-search-box__text-input"
                                                {...getInputProps({})}
                                              />
                                            </div>
                                            {tabValue === 1 &&
                                              suggestionEnabled &&
                                              showSuggestionCombo && (
                                                <div className="show-suggestions-btn-wrapper">
                                                  <IconButton
                                                    aria-label="more"
                                                    aria-controls="long-menu"
                                                    aria-haspopup="true"
                                                    onClick={
                                                      handleClickSuggestions
                                                    }
                                                  >
                                                    <MoreVertIcon />
                                                  </IconButton>
                                                  <SuggestionsFields
                                                    open={isOpen}
                                                    handleClose={handleClose}
                                                    familyFields={familyFields}
                                                    getSuggestions={
                                                      handleSuggestionFields
                                                    }
                                                  />
                                                </div>
                                              )}
                                          </div>
                                        ) : (
                                          <div
                                            className={`${
                                              tabValue === 1 &&
                                              suggestionEnabled &&
                                              showSuggestionCombo
                                                ? "show-suggestion"
                                                : ""
                                            } sui-search-box__wrapper relative`}
                                          >
                                            <div
                                              className={`${
                                                searchQuery.length > 0
                                                  ? "open-search"
                                                  : ""
                                              } icon-input`}
                                            >
                                              <input
                                                style={{ height: height }}
                                                className="sui-search-box__text-input"
                                                {...getInputProps({})}
                                              />
                                            </div>
                                            <div className="show-suggestions-btn-wrapper">
                                              {tabValue === 1 &&
                                                suggestionEnabled &&
                                                showSuggestionCombo && (
                                                  <IconButton
                                                    aria-label="more"
                                                    aria-controls="long-menu"
                                                    aria-haspopup="true"
                                                    onClick={
                                                      handleClickSuggestions
                                                    }
                                                  >
                                                    <MoreVertIcon />
                                                  </IconButton>
                                                )}
                                              <SuggestionsFields
                                                open={isOpen}
                                                handleClose={handleClose}
                                                familyFields={familyFields}
                                                config={config}
                                                setConfig={setConfig}
                                                getSuggestions={
                                                  handleSuggestionFields
                                                }
                                              />
                                            </div>
                                          </div>
                                        )}
                                        {showSearchButton && (
                                          <input
                                            {...getButtonProps({})}
                                            style={{ height: height }}
                                          />
                                        )}
                                      </>
                                    )}
                                    shouldClearFilters={shouldClearFilters}
                                    autocompleteMinimumCharacters={
                                      autocompleteMinimumCharacters
                                    }
                                    autocompleteSuggestions={false}
                                    searchAsYouType={true}
                                    debounceLength={300}
                                    onSubmit={(searchTerm) =>
                                      submitData(searchTerm)
                                    }
                                    inputProps={{
                                      placeholder:
                                        tabValue === 0
                                          ? t("WebCode")
                                          : t("Text/Ref./Keywords"),
                                      onKeyPress: onKeyPress,
                                      autoFocus: true,
                                    }}
                                  />
                                </Grid>
                              ) : (
                                selectorOnly &&
                                selectedProductsCode.length > 0 && (
                                  <Grid className="searchbar-right">
                                    <SearchBox
                                      inputView={({
                                        getAutocomplete,
                                        getInputProps,
                                        getButtonProps,
                                      }) => (
                                        <>
                                          <div className="selected-product-chip">
                                            {selectedProductsCode.length >
                                              0 && (
                                              <Chip
                                                label={selectedProductField}
                                                className="custom-select-chip"
                                                deleteIcon={<CloseIcon />}
                                                onDelete={() =>
                                                  onDeleteSelectedChip(
                                                    selectedProductsCode[0]
                                                  )
                                                }
                                              />
                                            )}
                                          </div>
                                          <div
                                            className={`${
                                              tabValue !== 1
                                                ? "no-suggestion"
                                                : ""
                                            } sui-search-box__wrapper relative`}
                                          >
                                            <div
                                              className={`${
                                                showLensIcon ? "icon-input" : ""
                                              } ${
                                                searchQuery.length > 0
                                                  ? "open-search"
                                                  : ""
                                              }`}
                                            >
                                              <input
                                                style={{ height: height }}
                                                className="sui-search-box__text-input"
                                                disabled={!visible}
                                                {...getInputProps({})}
                                              />
                                            </div>
                                            <div className="show-suggestions-btn-wrapper">
                                              {tabValue === 1 &&
                                                // suggestionEnabled &&
                                                showSuggestionCombo && (
                                                  <IconButton
                                                    aria-label="more"
                                                    aria-controls="long-menu"
                                                    aria-haspopup="true"
                                                    onClick={
                                                      handleClickSuggestions
                                                    }
                                                  >
                                                    <MoreVertIcon />
                                                  </IconButton>
                                                )}
                                              <SuggestionsFields
                                                open={isOpen}
                                                handleClose={handleClose}
                                                familyFields={familyFields}
                                                config={config}
                                                setConfig={setConfig}
                                                getSuggestions={
                                                  handleSuggestionFields
                                                }
                                              />
                                            </div>
                                          </div>

                                          {showSearchButton && (
                                            <input
                                              {...getButtonProps({})}
                                              style={{ height: height }}
                                            />
                                          )}
                                        </>
                                      )}
                                      shouldClearFilters={shouldClearFilters}
                                      autocompleteMinimumCharacters={
                                        autocompleteMinimumCharacters
                                      }
                                      autocompleteSuggestions={false}
                                      searchAsYouType={true}
                                      debounceLength={300}
                                      onSubmit={(searchTerm) =>
                                        submitData(searchTerm)
                                      }
                                      inputProps={{
                                        placeholder:
                                          tabValue === 0
                                            ? t("WebCode")
                                            : t("Text/Ref./Keywords"),
                                        onKeyPress: onKeyPress,
                                        autoFocus: true,
                                      }}
                                    />
                                  </Grid>
                                )
                              )}
                            </TabPanel>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  </div>
                </div>
                {visible && (
                  <div
                    className={`${
                      !showSearchButton ? "w-100" : ""
                    } sui-layout-body custom-search-wrap`}
                  >
                    <span
                      className="close-popup searchbarmodal"
                      onClick={closePopup}
                    >
                      <img
                        src={`../../newDesigning/images/close.svg`}
                        alt="close"
                      />
                    </span>
                    <div className="sui-layout-body__inner">
                      {(productResults || suggestionResults) &&
                        (suggestionResults?.results?.documents?.length > 0 ||
                          productResults?.length > 0) && (
                          <Grid
                            container
                            className="search-results-table-wrap show-on-mobile"
                          >
                            {suggestionEnabled && tabValue === 1 && (
                              <Grid
                                item
                                xs={12}
                                md={3}
                                className="sidebar-suggestion"
                              >
                                <AutoSuggest
                                  selected={selected}
                                  suggestionResults={suggestionResults}
                                  onClick={handleQuerySuggestions}
                                  searchQuery={searchQuery}
                                >
                                  {productResults /*&& selectedProductsCode*/ ? (
                                    productResults?.length > 0 /*&&
                                selectedProductsCode?.length >= 0*/ ? (
                                      <SearchResult
                                        searchQuery={searchQuery}
                                        data={productResults}
                                        rows={productResults}
                                        price_sort={price_sort}
                                        isFamilyFlag={isFamilyFlag}
                                        client_country_id={client_country_id}
                                        cart_products={cartList}
                                        fav_products={fav_products}
                                        jwt={jwt}
                                        elementId={elementId}
                                        api_url={api_url}
                                        api_origin={api_origin}
                                        logged={logged}
                                        express={express}
                                        tariff={tariffMap}
                                        sortField={sortField}
                                        lang={languageId}                                        
                                        familyData={family_list}
                                        showAddToCart={showAddToCart}
                                        showAddToList={showAddToList}
                                        sortDirection={sortDirection}
                                        showSelectButton={showSelectButton}
                                        showPlusQtyButton={showPlusQtyButton}
                                        showPlusButton={showPlusButton}
                                        customFilterManufacturer={customFilterManufacturer}
                                        customFilterManufacturerIds={customFilterManufacturerIds}
                                        handleSelectedProductClick={(code) =>
                                          handleSelectedProductClick(code)
                                        }
                                        selectedProductsCode={
                                          selectedProductsCode
                                        }
                                        resultsFields={resultsFields}
                                        openProduct={openProduct}
                                        openOn={openOn}
                                        onProductSelected={onProductSelected}
                                        onProductAddedToCart={
                                          onProductAddedToCart
                                        }
                                        onProductDeletedFromCart={
                                          onProductDeletedFromCart
                                        }
                                        onProductQtyModifiedOnCart={
                                          onProductQtyModifiedOnCart
                                        }
                                        onProductAddedToList={
                                          onProductAddedToList
                                        }
                                      />
                                    ) : (
                                      <Paper
                                        className={classes.paper}
                                        elevation={3}
                                      >
                                        <p>{PRODUCTS_NOT_FOUND}</p>
                                      </Paper>
                                    )
                                  ) : null}
                                </AutoSuggest>
                              </Grid>
                            )}
                            <Grid
                              item
                              xs={12}
                              md={suggestionEnabled && tabValue === 1 ? 9 : 12}
                              className={
                                suggestionEnabled && tabValue === 1 && selected
                                  ? "hide-on-mobile"
                                  : ""
                              }
                            >
                              {productResults /*&&
                          selectedProductsCode*/ && searchQuery.length > 0 ? (
                                productResults?.length > 0 /*&&
                            selectedProductsCode?.length >= 0*/ ? (
                                  <SearchResult
                                    searchQuery={searchQuery}
                                    data={productResults}
                                    rows={productResults}
                                    price_sort={price_sort}
                                    isFamilyFlag={isFamilyFlag}
                                    client_country_id={client_country_id}
                                    cart_products={cartList}
                                    fav_products={fav_products}
                                    jwt={jwt}
                                    elementId={elementId}
                                    api_url={api_url}
                                    api_origin={api_origin}
                                    logged={logged}
                                    express={express}
                                    tariff={tariffMap}
                                    sortField={sortField}
                                    lang={languageId}
                                    familyData={family_list}
                                    showAddToCart={showAddToCart}
                                    showAddToList={showAddToList}
                                    sortDirection={sortDirection}
                                    showSelectButton={showSelectButton}
                                    showPlusQtyButton={showPlusQtyButton}
                                    showPlusButton={showPlusButton}
                                    customFilterManufacturer={customFilterManufacturer}
                                    customFilterManufacturerIds={customFilterManufacturerIds}
                                    handleSelectedProductClick={(code) =>
                                      handleSelectedProductClick(code)
                                    }
                                    selectedProductsCode={selectedProductsCode}
                                    resultsFields={resultsFields}
                                    openProduct={openProduct}
                                    openOn={openOn}
                                    onProductSelected={onProductSelected}
                                    onProductAddedToCart={onProductAddedToCart}
                                    onProductDeletedFromCart={
                                      onProductDeletedFromCart
                                    }
                                    onProductQtyModifiedOnCart={
                                      onProductQtyModifiedOnCart
                                    }
                                    onProductAddedToList={onProductAddedToList}
                                  />
                                ) : (
                                  <Paper
                                    className={classes.paper}
                                    elevation={3}
                                  >
                                    <p>{PRODUCTS_NOT_FOUND}</p>
                                  </Paper>
                                )
                              ) : (
                                <>Loading...</>
                              )}
                              {showMoreResults &&
                                productResults?.length > 0 &&
                                searchQuery.length > 0 && (
                                  <div className="search-result-link">
                                    <a href={`/search?q=${searchQuery}`}>
                                      <Trans>{SHOW_MORE_RESULTS}</Trans>
                                    </a>
                                  </div>
                                )}
                            </Grid>
                          </Grid>
                        )}
                      {productResults ||
                      (suggestionResults &&
                        suggestionResults?.results?.documents?.length > 0) ? (
                        <Grid
                          container
                          className="hide-on-mobile search-results-table-wrap"
                        >
                          {suggestionEnabled && tabValue === 1 && (
                            <Grid
                              item
                              xs={12}
                              md={3}
                              className="sidebar-suggestion"
                            >
                              <AutoSuggest
                                selected={selected}
                                suggestionResults={suggestionResults}
                                onClick={handleQuerySuggestions}
                                searchQuery={searchQuery}
                              />
                            </Grid>
                          )}
                          {/* // suggestionEnabled &&
                        // suggestionResults && */}
                          <Grid
                            item
                            xs={12}
                            md={suggestionEnabled && tabValue === 1 ? 9 : 12}
                            className="relative"
                          >
                            {productResults /*&&
                        selectedProductsCode*/ && searchQuery.length > 0 ? (
                              productResults?.length > 0 /*&&
                          selectedProductsCode?.length >= 0*/ ? (
                                <SearchResult
                                  searchQuery={searchQuery}
                                  data={productResults}
                                  rows={productResults}
                                  price_sort={price_sort}
                                  isFamilyFlag={isFamilyFlag}
                                  client_country_id={client_country_id}
                                  cart_products={cartList}
                                  fav_products={fav_products}
                                  jwt={jwt}
                                  elementId={elementId}
                                  api_url={api_url}
                                  api_origin={api_origin}
                                  customFilterManufacturer={customFilterManufacturer}
                                  customFilterManufacturerIds={customFilterManufacturerIds}
                                  logged={logged}
                                  express={express}
                                  tariff={tariffMap}
                                  sortField={sortField}
                                  lang={languageId}
                                  familyData={family_list}
                                  showAddToCart={showAddToCart}
                                  showAddToList={showAddToList}
                                  sortDirection={sortDirection}
                                  showSelectButton={showSelectButton}
                                  showPlusQtyButton={showPlusQtyButton}
                                  showPlusButton={showPlusButton}
                                  handleSelectedProductClick={(code) =>
                                    handleSelectedProductClick(code)
                                  }
                                  selectedProductsCode={selectedProductsCode}
                                  resultsFields={resultsFields}
                                  openProduct={openProduct}
                                  openOn={openOn}
                                  onProductSelected={onProductSelected}
                                  onProductAddedToCart={onProductAddedToCart}
                                  onProductDeletedFromCart={
                                    onProductDeletedFromCart
                                  }
                                  onProductQtyModifiedOnCart={
                                    onProductQtyModifiedOnCart
                                  }
                                  onProductAddedToList={onProductAddedToList}
                                />
                              ) : (
                                <Paper className={classes.paper} elevation={3}>
                                  <p>{PRODUCTS_NOT_FOUND}</p>
                                </Paper>
                              )
                            ) : null}
                            {showMoreResults &&
                              productResults?.length > 0 &&
                              searchQuery.length > 0 && (
                                <div
                                  className={`${
                                    (!suggestionEnabled || tabValue === 0) &&
                                    "normal"
                                  } search-result-link`}
                                >
                                  <a href={`/search?q=${searchQuery}`}>
                                    <Trans>{SHOW_MORE_RESULTS}</Trans>
                                  </a>
                                </div>
                              )}
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid
                          container
                          className="hide-on-mobile search-results-table-wrap"
                        >
                          {SUGGESTIONS_NOT_FOUND}
                        </Grid>
                      )}
                    </div>
                  </div>
                )}
              </ErrorBoundary>
            </div>
          </div>
        </SearchProvider>
      </MyContext.Provider>
    </div>
  );
};

AppSearchBar.defaultProps = {
  width: width,
  height: height,
  languageId: languageId,
  engineCodeName: engineCodeName,
  engineFamilyName: engineFamilyName,
  searchFields: searchFields,
  exactSearch: exactSearch,
  suggestionCodeFields: suggestionCodeFields,
  suggestionFamilyFields: suggestionFamilyFields,
  suggestionEnabled: suggestionEnabled,
  showAddToCart: showAddToCart,
  showAddToList: showAddToList,
  showSearchButton: showSearchButton,
  showSelectButton: showSelectButton,
  showPlusQtyButton: showPlusQtyButton,
  showPlusButton: showPlusButton,
  showWebCodeTab: showWebCodeTab,
  showLensIcon: showLensIcon,
  showMoreResults: showMoreResults,
  showSuggestionCombo: showSuggestionCombo,
  selectorOnly: selectorOnly,
  openProduct: openProduct,
  openOn: openOn,
  searchTerm: searchTerm,
  autocompleteMinimumCharacters: autocompleteMinimumCharacters,
  searchAsYouType: searchAsYouType,
  onProductSelected: onProductSelected,
  onDeleteProductCode: onDeleteProductCode,
  onProductAddedToCart: onProductAddedToCart,
  onProductQtyModifiedOnCart: onProductQtyModifiedOnCart,
  onProductDeletedFromCart: onProductDeletedFromCart,
  onProductAddedToList: onProductAddedToList,
  shouldClearFilters: shouldClearFilters,
  filterCharacters: filterCharacters,
  numResults: numResults,
  resultsFields: resultsFields,
  productSelectedField: productSelectedField,
  filters: filters,
  customFilterManufacturer: customFilterManufacturer,
  customFilterManufacturerIds: customFilterManufacturerIds
};

export default AppSearchBar;

export const MyContext = createContext("");
